const MDS = (window as any).MDS;

const tableName = 'integritas';
// -------------------------- CREATE TABLE -------------------------- //
// Creates an SQL table in the database if it does not already exist

export const createSqlTable = () => {
  MDS.sql(`CREATE TABLE IF NOT EXISTS integritas (
  HASH varchar(1024) NOT NULL UNIQUE,
  VALIDATION_DATE datetime,
  FILE_NAME varchar(1024) NOT NULL,
  FILE_SIZE int NOT NULL,
  FILE_LABEL varchar(1024),
  FILE_DATE timestamp NOT NULL,
  JSON_FILE_NAME varchar(1024),
  JSON_PROOF CLOB,
  HASHES_GENERATED int,
  MATCHES_FOUND int,
  SUMMARY varchar(1024),
  VALID INT DEFAULT 2 CHECK (VALID IN (0, 1, 2)),
  VALIDATION_RESULT varchar(1024),
  VALIDATION_METHOD varchar(1024),
  VALIDATION_COMPLETE BOOLEAN DEFAULT FALSE,
  PROOF varchar(1024),
  PDF varchar(1024),
  TOKEN_ID varchar(1024),
  TOKEN_ID_INDEX int,
  TOKEN_TXPOW varchar(1024)
  )`);
};

// removed       INPUT_ADDRESS varchar(1024),
// Creates the blockchain-related table if it doesn't exist
export const createBlockchainTable = () => {
  MDS.sql(
    `CREATE TABLE IF NOT EXISTS blockchain (
      FILE_HASH varchar(1024) NOT NULL,
      BLOCK varchar(1024),
      DATE datetime,
      TXPOW_ID varchar(1024),
      TRANSACTION_ID varchar(1024),
      MATCHED_HASH varchar(1024),
      CHUNK_LENGTH int,
      HASHING_PACKET_SIZE int,
      HASHING_INDEX int,
      HASHING_OFFSET int
    )`,
  );
};
// Hash instances not remove:
//       HASH_INSTANCES int,

// -------------------------- CREATE RECORDS -------------------------- //
// Inserts a history record into the main table
export const createHistoryRecord = (
  hash: string,
  fileName: string,
  fileSize: number,
  fileDate: string,
  jsonFileName: string,
  jsonContent: string,
  validationMethod: string,
): Promise<IHistoryRecordResponse> => {
  return new Promise((resolve, reject) => {
    MDS.sql(
      `INSERT INTO ${tableName} (
        HASH,
        FILE_NAME,
        FILE_SIZE,
        FILE_LABEL,
        FILE_DATE,
        JSON_FILE_NAME,
        JSON_PROOF,
        VALIDATION_METHOD
        )
        VALUES (
          '${hash}',
          '${fileName}',
          ${fileSize},
          '',
          '${fileDate}',
          '${jsonFileName}',
          '${jsonContent}',
          '${validationMethod}'
        )`,
      function (response) {
        if (response.status) {
          resolve(response);
        } else {
          if (response.error.includes('Unique index or primary key violation')) {
            resolve({
              results: false,
              sql: response.sql,
              status: false,
              error: hash,
            });
          } else {
            reject(new Error('Failed to insert record.'));
          }
        }
      },
    );
  });
};

// if needed HASH_INSTANCES = numberOfResults (deleted)
// if needed INPUT_ADDRESS =           '${data.inputs_address}', (deleted)
// Inserts a new record in the blockchain table
export const createBlockchainHistoryRecord = (
  fileHash: string,
  blockchainDataList,
): Promise<IHistoryRecordResponse> => {
  return new Promise((resolve, reject) => {
    let sqlQuery = `
    INSERT INTO blockchain 
    (FILE_HASH, BLOCK, DATE, TXPOW_ID, TRANSACTION_ID, MATCHED_HASH, CHUNK_LENGTH, HASHING_PACKET_SIZE, HASHING_INDEX, HASHING_OFFSET) VALUES`;

    // Construct the values part of the query based on the number of items in blockchainDataList
    const values = blockchainDataList
      .map((data, index) => {
        return `(
          '${fileHash}', 
          '${data.block_number}', 
          '${data.block_date}', 
          '${data.txpow_id}', 
          '${data.transactionid}', 
          '${data.matched_hash}', 
          ${data.chunk_length},
          ${data.hashing_packet_size},
          ${data.hashing_index},
          ${data.hashing_offset}
        )`;
      })
      .join(', '); // Join all the values with commas to create multiple rows in the query.

    // Append the generated values to the base SQL query
    sqlQuery += values + ';';

    MDS.sql(sqlQuery, function (response) {
      if (response.status) {
        resolve(response);
      } else {
        reject(new Error('Failed to insert record.'));
      }
    });
  });
};
// -------------------------- UPDATE RECORDS -------------------------- //
// Updates the history record with validation results
export const updateHistoryRecord = (
  hash: string,
  validToNumber: number,
  validationResult: string,
  validationMethod: string,
  nftCoinId: number,
  nftTxpow: number,
): Promise<IHistoryRecordResponse> => {
  return new Promise((resolve, reject) => {
    MDS.sql(
      `UPDATE ${tableName} SET 
      VALID = ${validToNumber},
      VALIDATION_RESULT = '${validationResult}',
      VALIDATION_METHOD = '${validationMethod}',
      TOKEN_ID = '${nftCoinId}',
      TOKEN_TXPOW = '${nftTxpow}',
      VALIDATION_DATE = NOW()
      WHERE HASH = '${hash}'`,
      function (response) {
        if (response.status) {
          resolve(response);
        } else {
          reject(new Error('Failed to update record.'));
        }
      },
    );
  });
};

// -------------------------- UPDATE RECORDS -------------------------- //
// Updates the history record with validation results
export const updateCompletedHistoryRecord = (
  hash: string,
  validationComplete,
): Promise<IHistoryRecordResponse> => {
  return new Promise((resolve, reject) => {
    MDS.sql(
      `UPDATE ${tableName} SET 
      VALIDATION_COMPLETE = '${validationComplete}'
      WHERE HASH = '${hash}'`,
      function (response) {
        if (response.status) {
          resolve(response);
        } else {
          reject(new Error('Failed to update record.'));
        }
      },
    );
  });
};

// Update for timestamp combine file
export const updateJsonTimestampHistoryRecord = (
  jsonFileName: string,
  jsonContent,
  validationMethod: string,
  hash: string,
): Promise<IHistoryRecordResponse> => {
  return new Promise((resolve, reject) => {
    MDS.sql(
      `UPDATE ${tableName} SET 
      JSON_FILE_NAME = '${jsonFileName}',
      JSON_PROOF = '${jsonContent}',
      VALIDATION_METHOD = '${validationMethod}'
      WHERE HASH = '${hash}'`,
      function (response) {
        if (response.status) {
          resolve(response);
        } else {
          reject(new Error('Failed to update record.'));
        }
      },
    );
  });
};

// Updates history record that has been cancelled
export const updateHistoryRecordCancelled = (
  hash: string,
  validToNumber,
  validationResult,
): Promise<IHistoryRecordResponse> => {
  return new Promise((resolve, reject) => {
    MDS.sql(
      `UPDATE ${tableName} SET 
      VALID = ${validToNumber},
      VALIDATION_RESULT = '${validationResult}',
      VALIDATION_DATE = null
      WHERE HASH = '${hash}'`,
      function (response) {
        if (response.status) {
          resolve(response);
        } else {
          reject(new Error('Failed to update record.'));
        }
      },
    );
  });
};

// Updates the history record with token information
export const updateTokenIdHistoryRecord = (
  nftCoinId: string,
  i: number,
  nftTxpow: string,
  hash: string,
) => {
  return new Promise((resolve, reject) => {
    MDS.sql(
      `UPDATE ${tableName} SET 
      TOKEN_ID = '${nftCoinId}',
      TOKEN_ID_INDEX = ${i},
      TOKEN_TXPOW = '${nftTxpow}'
      WHERE HASH = '${hash}'`,
      function (response) {
        if (response.status) {
          resolve(response);
        } else {
          reject(new Error('Failed to update record with token id.'));
        }
      },
    );
  });
};

// Updates the file label in the history record
export const updateLabelHistoryRecord = (fileLabel: string, hash: string) => {
  return new Promise((resolve, reject) => {
    MDS.sql(
      `UPDATE ${tableName} SET 
      FILE_LABEL = '${fileLabel}'
      WHERE HASH = '${hash}'`,
      function (response) {
        if (response.status) {
          resolve(response);
        } else {
          reject(new Error('Failed to update record.'));
        }
      },
    );
  });
};

// Updates blockchain-related information in the history record
export const updateBlockchainHistoryRecord = (
  chunkLength: string,
  hashingPacketSize: string,
  hashingIndex: string,
  hashingOffset: string,
  hash: string,
): Promise<IHistoryRecordResponse> => {
  return new Promise((resolve, reject) => {
    MDS.sql(
      `
      UPDATE blockchain SET 
        CHUNK_LENGTH = '${chunkLength}',
        HASHING_PACKET_SIZE = '${hashingPacketSize}',
        HASHING_INDEX = '${hashingIndex}',
        HASHING_OFFSET = '${hashingOffset}'
      WHERE MATCHED_HASH = '${hash}'
      `,
      function (response) {
        if (response.status) {
          resolve(response);
        } else {
          reject(new Error('Failed to update record.'));
        }
      },
    );
  });
};

// Updates a record indicating it is invalid in the history table with NULL
export const updateInvalidHistoryRecord = (
  hash: string,
  validToNumber: number,
  validationResult: string,
): Promise<IHistoryRecordResponse> => {
  return new Promise((resolve, reject) => {
    MDS.sql(
      `UPDATE ${tableName} SET
      VALID = ${validToNumber},
      VALIDATION_RESULT = '${validationResult}',
      VALIDATION_DATE = NOW()
      WHERE HASH = '${hash}'`,
      function (response) {
        if (response.status) {
          resolve(response);
        } else {
          reject(new Error('Failed to update record.'));
        }
      },
    );
  });
};

// -------------------------- SELECT TABLE -------------------------- //
// Retrieves all records from the main history table
export const getHistoryRecords = (): Promise<HistoryResponse> => {
  return new Promise((resolve) => {
    MDS.sql(`SELECT * FROM ${tableName}`, function (response) {
      if (response.status) {
        resolve(response);
      }
    });
  });
};

export const getHistoryPaginationRecords = (
  perPage: number,
  currentPage: number,
  sortColumn: string,
  sortOrder: string,
): Promise<any> => {
  const offset = (currentPage - 1) * perPage;

  return new Promise((resolve) => {
    MDS.sql(`SELECT COUNT(*) AS total FROM ${tableName}`, function (countRes) {
      if (!countRes.status) {
        resolve({ data: '', totalPages: 0 });
      } else {
        const totalRecords = countRes.rows[0].TOTAL;
        const totalPages = Math.ceil(totalRecords / perPage);
        MDS.sql(
          `SELECT * FROM ${tableName} ORDER BY ${sortColumn} ${sortOrder} LIMIT ${perPage} OFFSET ${offset}`,
          function (dataRes) {
            if (dataRes.status) {
              resolve({ data: dataRes, totalPages, totalRecords });
            }
          },
        );
      }
    });
  });
};

export const searchHistoryRecords = (searchTerm: string): Promise<HistoryResponse> => {
  return new Promise((resolve) => {
    MDS.sql(
      `
      SELECT * FROM ${tableName}
      WHERE UPPER(FILE_NAME) LIKE '%${searchTerm}%' 
          OR FILE_LABEL LIKE '%${searchTerm}%'
          OR FILE_SIZE LIKE '%${searchTerm}%'
          OR VALIDATION_DATE LIKE '%${searchTerm}%'
       ORDER BY VALIDATION_DATE DESC
      `,
      function (response) {
        if (response.status) {
          resolve(response);
        } else {
          resolve({ count: 0, results: false, rows: [], sql: '', status: false });
        }
      },
    );
  });
};

// Retrieves all records from the blockchain history table
export const getBlockchainHistoryRecords = (): Promise<HistoryResponse> => {
  return new Promise((resolve) => {
    MDS.sql(`SELECT * FROM blockchain`, function (response) {
      if (response.status) {
        resolve(response);
      }
    });
  });
};

// Retrieves blockchain history for a specific file with file hash
// -- Select distinct HASH from the specified table and all columns from the blockchain table

// -- Perform a LEFT JOIN between the specified table and the blockchain table
// -- where the HASH in the specified table matches the FILE_HASH in the blockchain table

// -- Filter the results by the file hash passed to the query, so it only returns data for the specified file
export const getDetailsBlockchainHistory = (fileHash: string): Promise<HistoryResponse> => {
  return new Promise((resolve) => {
    MDS.sql(
      `
      SELECT DISTINCT ${tableName}.HASH, blockchain.* 
      FROM ${tableName}
      LEFT JOIN blockchain 
      ON ${tableName}.HASH = blockchain.FILE_HASH 
      WHERE ${tableName}.HASH = '${fileHash}'`,
      function (response) {
        if (response.status) {
          resolve(response);
        }
      },
    );
  });
};

// -------------------------- DROP TABLE -------------------------- //
// Deletes history for specific hash //
export const deleteRecordsByHash = async (hash: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    MDS.sql(`DELETE FROM ${tableName} WHERE HASH = '${hash}'`, function (response) {
      if (!response.status) {
        return reject(new Error(`Failed to delete from ${tableName}: ${response.error}`));
      }

      MDS.sql(`DELETE FROM blockchain WHERE FILE_HASH = '${hash}'`, function (blockchainResponse) {
        if (blockchainResponse.status) {
          resolve();
        } else {
          reject(new Error(`Failed to delete from blockchain: ${blockchainResponse.error}`));
        }
      });
    });
  });
};

// -------------------------- DROP TABLE -------------------------- //
// Deletes blockchain history for specific hash //
export const deleteBlockchainRecordsByHash = async (hash: string): Promise<void> => {
  console.log(`DELETING BLOCKCHAIN RECORDS FROM ${hash}`);

  return new Promise((resolve, reject) => {
    MDS.sql(`DELETE FROM blockchain WHERE FILE_HASH = '${hash}'`, function (blockchainResponse) {
      if (blockchainResponse.status) {
        resolve();
      } else {
        reject(new Error(`Failed to delete from blockchain: ${blockchainResponse.error}`));
      }
    });
  });
};
